import apiMaintenanceSchedule from 'services/inventory/maintenance-schedule'

export const handleSave = async (values: any) => {
  let res = await apiMaintenanceSchedule.createInspection(values)

  return res?.data?.success
}
